export default function NewApplication() {
  return (
    <div className='relative w-screen h-screen flex flex-col items-center justify-center font-mont'>
      <div className='rounded-md flex flex-col'>
        <div className='bg-green-400/75 p-4 flex rounded-t-md'>
          <p className='w-full text-center text-white font-bold text-3xl'>THANK YOU</p>
        </div>
        <div className='flex flex-col items-center gap-4 bg-blue-900/75 p-4 rounded-b-md'>
          <p className='text-white'>It has been an honor to help 250,000 Self-Employed Americans Claim $200 million in pandemic era tax credits</p>
          <p className='text-orange-400 text-2xl'>THE DEADLINE TO APPLY HAS EXPIRED.</p>
          <p className='text-white'>Existing customer? Our support team is still available to answer your questions.</p>
          <p className='text-white'>Call: 1-833-738-2776</p>
        </div>
      </div>
    </div>
  )
}